module.exports = __webpack_public_path__ + "static/media/xiaoshouluojilian.60fd3858.png";